import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { IcmsComponent } from './icms.component';
import { AuthGuard } from 'app/_guards/auth.guard';

const usuariosRoutes: Routes = [
    { path: '', component: IcmsComponent, canActivate: [AuthGuard] },
];

@NgModule({
    imports: [RouterModule.forChild(usuariosRoutes)],
    exports: [RouterModule]
})
export class IcmsModuleRoutingModule {}
